import { render, staticRenderFns } from "./LightboxWagtailPageStruct.vue?vue&type=template&id=7e239015&scoped=true&"
import script from "./LightboxWagtailPageStruct.vue?vue&type=script&lang=js&"
export * from "./LightboxWagtailPageStruct.vue?vue&type=script&lang=js&"
import style0 from "./LightboxWagtailPageStruct.vue?vue&type=style&index=0&id=7e239015&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e239015",
  null
  
)

export default component.exports